namespace Serenity.EmailClient {

    @Decorators.registerClass()
    @Decorators.maximizable()
    export class EmailComposeDialog extends Serenity.PropertyDialog<EmailComposeRequest, any> {

        private form: EmailComposeForm = new EmailComposeForm(this.idPrefix);

        constructor() {
            super();

            this.dialogTitle = Q.text("Site.EmailClient.NewEmailDialogTitle");
        }

        protected getFormKey() {
            return EmailComposeForm.formKey;
        }

        private _reply: EmailReplyResponse;

        get reply(): EmailReplyResponse {
            return this._reply;
        }

        set reply(value: EmailReplyResponse) {
            if (this._reply != value) {
                this._reply = value;

                if (this._reply) {
                    this.dialogTitle = Q.text("Site.EmailClient.ReplyEmailDialogTitle");
                    this.form.To.element.val(this._reply.To);
                    this.form.Cc.element.val(this._reply.Cc);
                    this.form.Subject.value = this._reply.Subject;
                    this.form.BodyHtml.value = this._reply.ReplyBody;

                    if (this._reply.Attachments) {
                        this.form.Attachments.value = this._reply.Attachments.map(x => (<Serenity.UploadedFile>{
                            Filename: x.DownloadUrl,
                            OriginalName: x.FileName
                        }));
                    }
                }
            }
        }

        protected getDialogButtons() {
            return [
                {
                    text: Q.text("Site.EmailClient.SendButton"),
                    click: () => {
                        if (!this.validateForm())
                            return;

                        var request = this.getSaveEntity();

                        EmailService.Compose(request, response => {
                            this.dialogClose();
                        });
                    }
                },
                {
                    text: Q.text("Site.EmailClient.CancelButton"),
                    click: () => this.dialogClose()
                }

            ];
        }

        protected getDialogOptions() {
            var opt = super.getDialogOptions();
            opt.width = 960;
            return opt;
        }
    }
}